<template>
    <b-modal no-close-on-backdrop centered size="lg"
        modal-class="x-modal"
        title="IMPORT CHAT OF ACCOUNT"
        ref="innerform"
        footer-class="justify-content-between"
        @shown="formInit">
        <div class="vl-parent" ref="ldCond">
            <div class="row">
                <div class="col-sm-4">
                    <select class="form-control form-control-sm" v-model="query.TypeId" @change="onTypeChange">
                        <option value="0">System Date</option>
                        <option value="1">Quickbook</option>
                        <option value="2">System Template</option>
                    </select>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <select class="form-control form-control-sm" v-model="query.AccountTypeId" @change="formInit">
                            <option value="">{{$t('all')}}</option>
                            <option v-for="ret in accountTypes" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                        </select>
                    </div>
                </div>
                <div v-if="query.TypeId!=0" class="col-sm-4">
                    <input type="file" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="file" style="display: none;" @change="onUpload">
                    <button type="button" class="btn btn-success btn-sm" @click="$refs.file.click()">{{$t('choose_excel_file')}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <b-table :fields="fields" :items="records" ref="table"
                        selectable
                        @row-selected="onRowSelected"
                        selected-variant="primary"
                        class="table-sm no-bor">
                    </b-table>
                </div>
            </div>
        </div>
        <template #modal-footer>
            <div>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="$refs.table.selectAllRows()"><i class="fa fa-check-square" aria-hidden="true"></i> SELECT ALL</button>&nbsp;
                <button type="button" class="btn btn-outline-danger btn-sm" @click="$refs.table.clearSelected()"><i class="fa fa-ban" aria-hidden="true"></i> UNSELECT ALL</button>
            </div>
            <div><button type="button" class="btn btn-outline-success btn-sm" @click="onSave" :disabled="itemSelects.length==0"><i class="fa fa-copyright" aria-hidden="true"></i> COPY</button></div>
        </template>
    </b-modal>
</template>
<script>
export default{
    data(){
        return {
            query: {
                TypeId: 0,
                AccountTypeId: ''
            },
            records: [],
            fields: [
                { key: 'Name' },
                { key: 'Num' },
                { key: 'AccountTypeName' },
                { key: 'Description' }
            ],
            header: {
                'Content-Type': 'multipart/form-data'
            },
            itemSelects: [],
            accountTypes: []
        }
    },
    async created(){
        var res = await this.$api().post('accounting/types', {});
        if (this.$isValid(res)) {
            this.accountTypes = res.data.Json.Types;
        }
    },
    methods: {
        formInit(){
            let loading = this.$loading.show({
                container: this.$refs.ldCond
            });
            this.query.CompanyId = this.$store.state.company.Id;
            this.$api().post('accounting/account-master', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Accounts;
                }
            }).finally(() => { loading.hide(); });
        },
        onUpload(){
            var formData = new FormData();
            formData.append("TypeId", this.query.TypeId);
            formData.append('File', this.$refs.file.files[0]);
            let loading = this.$loading.show();
            this.$api().post('accounting/account-upload', formData, this.header).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Coas;
                }
            }).finally(() => { loading.hide(); });
        },
        onRowSelected(items){
            this.itemSelects = items;
        },
        onSave() {
            let loading = this.$loading.show({
                container: this.$refs.ldCond
            });
            for (let i = 0; i < this.itemSelects.length; i++) {
                let account = this.itemSelects[i];
                account.CompanyId = this.$store.state.company.Id;
                account.ClientId = this.$store.state.company.ClientId;
            }
            this.$api().post('accounting/account-import-save', this.itemSelects).then(res => {
                if(this.$isValid(res)){
                    this.itemSelects = [];
                    this.$emit('done');
                }
            }).finally(() => { loading.hide(); });
        },
        onTypeChange(){
            this.records = [];
            this.itemSelects = [];
            if(this.query.TypeId == 0) this.formInit();
        }
    }
}
</script>